import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Studio from "@/pages/Studio";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentReturn";
import "@/premium.css";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", color: "var(--muted)", fontFamily: "var(--mono)", fontSize: 13 }}>
        Cargando…
      </div>
    );
  if (user === false) return <Navigate to="/auth?next=/studio" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/studio" element={<Protected><Studio /></Protected>} />
          <Route path="/studio/:id" element={<Protected><Studio /></Protected>} />
          <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" theme="light" richColors />
    </AuthProvider>
  );
}

export default App;
